<template>
	<div>
		<div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>

		<section>
			<div id="spearhead">
				<div v-if="protocol || personContact.name || personContact.phone || queue" class="d-flex">
					<!-- <div class="spearhead-element" v-if="cpd && cpd !== ''">
						<span><i class="fas fa-phone"></i>
							<b>CPD: </b></span>
						<p>{{ cpd }}</p>
					</div> -->

					<div class="spearhead-element">
						<span><i class="fas fa-clipboard"></i>
							<b>Protocolo</b></span>
						<p v-if="protocol">{{ protocol }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element" v-if="cpd && cpd !== ''">
						<span><i class="fas fa-user"></i><b>CPD: </b></span>
						<p>{{ cpd }}</p>
					</div>

					<div class="spearhead-element" v-if="razaoSocial">
						<span><i class="fas fa-building"></i><b>Razão Social</b></span>
						<p>{{ razaoSocial }}</p>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-user"></i><b>Cliente</b></span>
						<p v-if="personContact.name">
							{{ personContact.name }}
							<span v-if="nomeURA"> | {{ nomeURA }}</span>
						</p>
						<p v-else>----------</p>
					</div>


					<div class="spearhead-element telefone">
						<span><i class="fas fa-phone-alt"></i><b>Telefone</b></span>
						<p>{{ formatPhoneNumber(clientPhone) }}</p>
					</div>


					<div class="spearhead-element" v-if="email && email.trim() !== ''">
						<span><i class="fas fa-envelope"></i><b>E-mail</b></span>
						<p>{{ email }}</p>
					</div>



					<!-- <div class="spearhead-element">
						<span><i class="fas fa-user"></i><b>Cliente</b></span>
						<p v-if="personContact.name">{{ personContact.name }}</p>
						<p v-else>----------</p>
					</div> -->






					<div class="spearhead-element">
						<span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
						<p v-if="queue">{{ queue }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-clock"></i><b>Tempo da Sessão</b></span>
						<p v-if="session">{{ formatDate(session) }}</p>
						<p v-else>----------</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import validarTel from '../../store/modules/validarTel'

export default {
	data() {
		return {
			interval: '',
			time: '',
			timeFormat: '',
			protocol: '',
			queue: '',
			cpd: '',
			email: '',
			clientPhone: '',
			nomeURA: '',
			session: '',
			razaoSocial: '',
			personContact: {
				'name': '',
				'phone': '',
			},
		}
	},
	methods: {

		...mapActions(['']),
		formatCpf(cpf) {
			try {
				cpf = cpf.replace(/[^\d]/g, "");
				return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			} catch (e) {
				return cpf;
			}
		},
		rawPhone(phone) {
			if (!phone) return '';
			return phone.split('@')[0]; 
		},
		formatPhoneNumber(phone) {
			if (!phone) return '';
			if (phone.includes('@')) {
				phone = phone.split('@')[0];
			}
			const onlyNumbers = phone.replace(/[^\d]/g, '');
			if (onlyNumbers.length === 13 && onlyNumbers.startsWith('55')) {
				return `+${onlyNumbers.slice(0, 2)} ${onlyNumbers.slice(2, 4)} ${onlyNumbers.slice(4, 9)}-${onlyNumbers.slice(9)}`;
			}
			if (onlyNumbers.length === 11) {
				return `+55 ${onlyNumbers.slice(0, 2)} ${onlyNumbers.slice(2, 7)}-${onlyNumbers.slice(7)}`;
			}
			if (onlyNumbers.length === 12 && onlyNumbers.startsWith('55')) {
				return `+${onlyNumbers.slice(0, 2)} ${onlyNumbers.slice(2, 4)} ${onlyNumbers.slice(4, 8)}-${onlyNumbers.slice(8)}`;
			}

			return onlyNumbers;
		},



		formatPersonData() {
			try {
				this.person.fullName = this.person.fullName.trim();
			} catch (e) {
				console.error('Cliente sem nome');
			}

			return `<b>Nome:</b> ${this.person.fullName} <b>Idade:</b> ${this.person.age} <b>Data de Nascimento:</b> ${this.person.birthday} <b>CPF:</b> ${this.formatCpf(this.person.CPF)}`;
		},
		formatPersonContact() {
			return `<b>Numero:</b> ${this.personContact.phone}  <b>Protocolo:</b> ${this.protocol}`;
		},
		formathealthInssurance() {
			return `<b>Convenio:</b> ${this.healthInssurance.name} - <b>Registro:</b> ${this.healthInssurance.id}`;
		},
		formatAddress() {
			return `${this.ende.address}, ${this.ende.num}, ${this.ende.city} - ${this.ende.CEP}`;
		},
		formatDate(date) {
			if (!date) return '';
            return window.moment(date).add(1, 'days').format('DD/MM/YYYY HH:mm:ss');
        },

		async setClientData(client) {
			let clientName = '';
			let phoneEdited = '';
			this.protocol = '';
			this.queue = '';
			this.email = '';
			this.session = client.sessionDate || new Date().toISOString();

			this.cpd = client.cpd || client.cpdnovo || '';

			if (this.getPhone) {
				if (client.type === 'chat') {
					let phoneArr = client.phone.split('@');
					phoneEdited = validarTel.formata_telefone(phoneArr[0].substr(2));
				}

				this.personContact = {
					'name': client.name || phoneEdited,
					'phone': phoneEdited,
				};

				this.queue = client.queue === 'entrante' ? 'Atendimento Ativo' : client.queue;
				this.protocol = client.protocol;
				this.email = client.email || this.$store.getters.getDataConnectLine.email || '';
			}

			if (client.phone && (!this.cpd || this.cpd === '' || this.cpd === null)) {
				try {
					const { data } = await axios.get(`/share-client-cnpj?share=${client.phone}`);
					if (data.length > 0) {
						this.cpd = data[0].cpd || '';
						clientName = data[0].name || client.phone;
					}
				} catch (err) {
					console.error('Erro ao buscar dados do cliente via /share-client-cnpj', err);
					clientName = client.phone;
				}
			}

			this.personContact = {
				'name': clientName || client.name || '',
				'phone': client.phone || phoneEdited || ''
			};

			if (client.type === 'phone') {
				this.clientPhone = client.clientPhone || client.phone?.replace('@s.whatsapp.net', '') || '';
			}


		}


	},
	computed: {
		...mapGetters(['isReconnect', 'getDataConnectLine', 'getPhone', 'getDataLog']),
	},
	watch: {
		getDataConnectLine(val) {
			const dataToSave = {
            cliente: val,
            session: this.session 
        };
			localStorage.setItem("clienteAtual", JSON.stringify(val));
			this.hasData = !!Object.keys(val).length;
			this.setClientData(val);

			if (Object.keys(val).length === 0) {
				this.personContact = {
					'name': '',
					'phone': ''
				}
				this.protocol = '';
				this.queue = '';
				this.cpd = '';
				this.session = '';
				this.clientPhone = val.clientPhone || '';

				this.nomeURA = val.nomeURA || '';

			}
		},
		getDataLog(myLog) {
			this.session = myLog.sessionDate || new Date().toISOString();
			this.email = myLog.email || ''; 
			this.cpdnovo = myLog.cod_cliente || 'não informado'
			this.nomeURA = myLog.cliente_nome || '';
			this.clientPhone = myLog.client_id || '';
			this.razaoSocial = myLog.nom_cliente || '';

			if (!this.cpd || this.cpd === '') {
				this.cpd = myLog.cpd || '---';
			}
		}
	},
	mounted() {
		if (!localStorage.getItem("clienteAtual")) {
			this.hasData = false;
			return;
		}

		const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
		if (Object.keys(clienteAtual).length) {
			this.hasData = true;
			this.setClientData(clienteAtual);
		}
	}
}
</script>

<style scoped>
#spearhead {
	display: flex;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
	border-radius: 0px 0px 14px 14px;
	font-size: 11px;
	background-color: white;
	margin: 2px;
	box-shadow: -1px 5px 7px 0px #9f9999;
	transition: 0.7s;
	transition-timing-function: ease;
	height: max-content;
}

.spearhead-element.telefone {
	min-width: 150px; 
}

.spearhead-element {
	display: flex;
	flex-direction: column;
	text-align: center;
	border-right: 1px solid lightgray;
	border-left: 1px solid lightgray;
	padding: 0px 10px;
}

.spearhead-element span {
	font-size: 12px;
	text-align: center;
}

.center {

	display: flex;
	align-items: center;
	justify-content: center;
}

.reconnect-feedback {
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: gray;
	color: white;
}

.parte-cima {
	box-shadow: 5px 3px 6px -6px black;
	padding: 1px 5px 2px 20px;
	background-color: #ECF0F1;
	max-height: 10em;
	overflow-x: auto;
}

.row {
	margin-right: 0 !important;
}

::-webkit-scrollbar {
	width: 0.18rem;
}

::-webkit-scrollbar-track {
	background: #f38630;
}

::-webkit-scrollbar-thumb {
	background: #1c869a;
}

.espaco-lado-lado {
	max-width: 270px;
	width: 100%;
	margin: 0.1em 0 0.1em 0;
}

.img {
	height: 1.7em;
}

b {
	font-size: 1.1em;
	margin-left: 0.5em;
}

p {
	margin: 0 5px;
}

span {
	font-size: 20px;
}
</style>
